import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnInit,
  ViewChildren,
  ElementRef,
  QueryList, ChangeDetectorRef, ViewChild, Signal, inject
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import {
  clusterData,
  rankingData,
  retailerData,
  sectorData
} from "../../shared/toolbox/dialogs/compare-dialog/compareDialogInterfaces";
import {HttpClient} from "@angular/common/http";
import {toSignal} from "@angular/core/rxjs-interop";
import {map, tap} from "rxjs";
import {MediaQueryService} from "../../services/media-query/media-query.service";



@Component({
  selector: 'app-list-profile',
  templateUrl: './list-profile.component.html',
  styleUrls: ['./list-profile.component.scss'],
  standalone: false /*
  imports: [
    NgClass,
    DialogComponent,
    LowerCasePipe,
    FormsModule,
    CompareDialogComponent,
    EchelonComponent
  ],*/,
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden',
          margin: 0,
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
          margin: '*',
        })
      ),
      transition('collapsed <=> expanded', [animate('0.5s ease-in-out')]),
    ]),
  ],
})
export class ListProfileComponent implements AfterViewInit, OnInit {
  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    public snack: MatSnackBar,
    public auth: RxAuthService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  @Input() listProfile: any = {};
  tableIsExpanded: boolean = false;
  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService.getDisplayType().pipe(
      map(({isMobile}) => isMobile)),
    {initialValue: window.innerWidth < 767}
  );

  selectedList: any = this.listProfile.current_list;

  echelonHeaders: string[] = [];
  echelonNameWithSpaces: string | null = null;
  combinedSelected: (retailerData | rankingData | sectorData | clusterData)[] = [];

  compareID: string | null = null;

  @Output() compareTo: EventEmitter<any> = new EventEmitter();

  @ViewChildren('echelonElement', {read: ElementRef}) echelonElements!: QueryList<any>;
  @ViewChild('exportDropdown') exportDropdown!: ElementRef;

  public sponsorIcons = [];

  ngOnInit() {
    this.compareID = this.route.snapshot.queryParamMap.get('compare')
    if (this.compareID) {
      this.setComparePills()
    }

    this.selectedList = this.listProfile.all_lists.find(
      (list: any) => list.name == this.listProfile.current_list.name
    );
    let expanded = this.route.snapshot.queryParamMap.get('expanded');
    //console.log(this.listProfile)
    if (expanded === 'true') {
      this.tableIsExpanded = true;
    }

    // Sort retailers by name within each cluster
    if (this.listProfile.list_cluster_object) {
      this.listProfile.list_cluster_object.forEach((cluster: any) => {
        cluster.retailers.sort((a: any, b: any) =>
          a.name.localeCompare(b.name)
        );
      });
    }

    this.updateSponsorIcons(this.listProfile);

  }

  ngAfterViewInit() {

    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length > 0 && this.listProfile.echelons.length > 0 && 'echelon' in params) {
        const echelonNameWithDashes = params['echelon'];
        this.echelonNameWithSpaces = this.replaceDashWithSpace(echelonNameWithDashes)
      } else {
        console.log("continue")
      }
    });
    this.getEchelonHeaders();
  }

  setComparePills() {
    let current_page_ID = this.route.snapshot.queryParamMap.get('id')

    let url = `${environment.backend_base}main/retailer/get_rcls_compare_profile_pill_info/`
    let payload = {
      rcls: this.compareID,
      current_id: current_page_ID,
    }
    this.http.post(url, payload).subscribe((response: any) => {
        this.combinedSelected = response
        this.combinedSelected = this.combinedSelected.map((item: any) => {
          if ((item.type === 'cluster' || item.type === 'sector') && item.in_list_name) {
            return {
              ...item,
              name: `${item.name} (${item.in_list_name})`
            };
          }
          return item;
        });
      }, (error) => {
        console.error("Error when accessing compare pill information: ", error)
      }
    )
    console.log(this.combinedSelected)
    this.cdr.detectChanges()
  }

  scrollToMatchingEchelon() {
    setTimeout(() => {
      const matchingEchelon = this.echelonElements.toArray().find((elementRef) => {
        const headerElement = elementRef.nativeElement.querySelector('.echelon-header p:first-child');
        return headerElement &&
          headerElement.innerText.trim().toLowerCase() === this.echelonNameWithSpaces?.trim().toLowerCase();
      });


      if (matchingEchelon) {
        const elementPosition = matchingEchelon.nativeElement.getBoundingClientRect().top + window.scrollY;
        const headerHeight = document.querySelector('header')?.offsetHeight || 0;

        // Scroll to the target element ensuring it aligns at the very top
        window.scrollTo({
          top: elementPosition - headerHeight,
          behavior: 'smooth'
        });

        // Wait for the scroll animation to finish, then open the echelon
        setTimeout(() => {
          const echelonComponent = matchingEchelon.componentInstance; // Access the Angular component instance
          // Trigger the click event on the expand button in the footer to toggle content
          const footerElement = matchingEchelon.nativeElement.querySelector('.echelon-footer .expand-button');
          if (footerElement) {
            footerElement.click(); // Trigger the click event to toggle content
          }

        }, 1000); // Adjust this delay to match the scroll duration

      } else {
        console.warn('Matching echelon not found:', this.echelonNameWithSpaces);
      }
    }, 1000); // Ensure the DOM is fully rendered before scrolling
  }

  getEchelonHeaders(retryCount = 0, maxRetries = 10) {
    setTimeout(() => {
      const headers = this.echelonElements.toArray().map((elementRef) => {
        const headerElement = elementRef.nativeElement.querySelector('.echelon-header p:first-child');

        if (headerElement) {
          return {
            text: headerElement.innerText,
            position: headerElement.getBoundingClientRect().top + window.scrollY
          };
        }
        return null;
      }).filter(header => header !== null);

      if (headers.length === 0 && retryCount < maxRetries) {
        console.warn(`Retrying... Attempt ${retryCount + 1}`);
        this.getEchelonHeaders(retryCount + 1, maxRetries);
      } else {
        this.echelonHeaders = headers.map(header => header?.text);
        this.scrollToMatchingEchelon()// Extract only text values
      }
    }, 300); // Adjust delay if needed
  }

  replaceDashWithSpace(dashedString: string): string {
    return dashedString.replace(/-/g, ' '); // Replaces all dashes with spaces
  }

  updateSponsorIcons(listProfile: any) {
    // if (this.listProfile.rcl_id === 4872) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Syndeo.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Stripe.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Imagino.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Avalara.svg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Akeneo.png',
    //   ];
    // } else if (this.listProfile.rcl_id === 2579) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_BlueYonder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Contentful.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Navan.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Mirakl.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Tns.png',
    //   ];
    // } else if (this.listProfile.rcl_id === 6186 || this.listProfile.rcl_id === 6066) {
    //   this.sponsorIcons = [
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Asendia.jpg',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_BlueYonder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Bynder.png',
    //     'https://retailx-public-media.s3.eu-west-2.amazonaws.com/list-images/Logo_Kbrw.png',
    //   ];
    if (listProfile.current_list.sponsors.length > 0) {
      this.sponsorIcons = listProfile.current_list.sponsors.map((sponsor: any) => sponsor.logo);
    } else {
      this.sponsorIcons = [];
    }
  }

}

